<template>
    <v-form v-model="form" ref="form_step_2">
        <v-card class="mt-5">
            <v-card-title class="grey lighten-4 p-2">
                <h4 class="m-0">Confirm Reservation</h4>
            </v-card-title>
            <v-row>
                <v-col>
                    <ticket-information></ticket-information>
                </v-col>
                <v-col>
                    <rental-information></rental-information>
                </v-col>
            </v-row>
            <additional-information v-if="notes_on_kiosk"></additional-information>
        </v-card>
        <renters-list-table class="mt-2" title="Renters list" :no-action="true"></renters-list-table>
        <template v-if="gateway =='stripe'">
            <template v-if="!cost.free_checkout">
                <v-col cols="12" v-if="(is_prepay && (prepay_payment || only_save_card_at_prepay)) || (((is_seasonal && !advance_seasonal) && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || ((is_seasonal && advance_seasonal) && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)))  || (!is_seasonal && (full_charge_at_kiosk || swipeMode))">
                    <v-card class="mt-5">
                        <v-card-title class="grey lighten-4 p-2" v-if="!kiosk_save_only">
                            <h4 class="m-0">
                                <span class=" error--text"> Reservation Total:</span> <span class="blue--text text--accent-4">${{ amount }}</span>
                            </h4>
                        </v-card-title>
                        <v-card-title class="grey lighten-4 p-2" v-else-if="kiosk_save_only && !fullCharge">
                            <h5 class="m-0 font-weight-bold error--text text-break">
                                We are saving your card information and are not charging you at this time
                            </h5>
                        </v-card-title>
                        <div class="p-2">

                    <span class="mt-5 error--text  text-break" v-if="reservation.is_seasonal && securitydeposit && !swipeMode && frontend_view_folder == 'frontend.highcountryskiandtennis'">
                        Please Enter Credit Card Information that is used as a security Deposit.
                    </span>

                            <template v-if="((!securitydeposit && is_seasonal && frontend_view_folder == 'frontend.highcountryskiandtennis') || !is_seasonal || (is_seasonal && frontend_view_folder !== 'frontend.highcountryskiandtennis')) && kiosk_save_only">
                                <div :class="(is_seasonal && kiosk_save_only)?'error--text':'mt-5 error--text'"> Reservation Total: <span class="blue--text text--accent-4">${{ amount }}</span></div>
                            </template>
                            <template v-if="securitydeposit && kiosk_save_only && is_seasonal && frontend_view_folder == 'frontend.highcountryskiandtennis'">
                                <div class=""> Total Rental: <span class="blue--text text--accent-4">${{ parseFloat( parseFloat(amount) - cost.deposit_total ).toFixed(2) }}</span></div>
                                <div class="error--text"> Deposit: <span class="blue--text text--accent-4">${{ parseFloat( cost.deposit_total ).toFixed(2) }}</span></div>
                                <div class="mb-5 error--text"> Total: <span class="blue--text text--accent-4">${{ parseFloat( amount ).toFixed(2) }}</span></div>
                            </template>
                            <template v-if="cash_pay_switch && (reservation.is_from_kiosk == 1 && (((reservation.is_seasonal && seasonal_kiosk_cash_pay) || (!reservation.is_seasonal && kiosk_cash_pay))))">
                                <span class="mt-5">
                                    <with-validation :context='self()' v-slot="{bind,on}" field="kiosk_cash_pay">
                                        <v-checkbox
                                            v-bind="bind"
                                            v-on="on"
                                            :true-value="true"
                                            :false-value="false"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    I prefer to pay cash at the register
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </with-validation>
                                </span>
                            </template>
                            <div id="card-element"></div>
                        </div>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <with-validation field="agreement" v-slot="{bind,on}">
                        <v-checkbox v-bind="bind"
                                    v-on="on" v-if="(is_prepay && (prepay_payment || only_save_card_at_prepay)) || (((is_seasonal && !advance_seasonal) && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || ((is_seasonal && advance_seasonal) && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)))  || (!is_seasonal && (full_charge_at_kiosk || swipeMode))">

                            <template v-slot:label>
                                I have read and agree to the
                                &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_terms'})">{{ terms_and_conditions_title }}</a>
                                ,
                                &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_privacy_policy'})">{{ privacy_policy_title }}</a>&nbsp;
                                and
                                &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_cancelation_policy'})">{{ cancellation_policy_title }}</a>
                            </template>
                        </v-checkbox>
                    </with-validation>
                </v-col>
            </template>
            
            <template v-if="((is_prepay && (prepay_payment || only_save_card_at_prepay)) || (is_seasonal && !advance_seasonal && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || (is_seasonal && advance_seasonal && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)) || (!is_seasonal && (full_charge_at_kiosk || swipeMode))) && !cost.free_checkout">
                <template v-if='$store.state.resources.config.google_recaptcha=="1" && $store.state.resources.config.google_recaptcha_site_key!=""'>
                    <div class="mt-5">
                        <h6>This site is protected by Google reCAPTCHA</h6>
                    </div>
                </template>
            </template>
            <template v-show="(is_prepay && (prepay_payment || only_save_card_at_prepay)) || (is_seasonal && !advance_seasonal && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || (is_seasonal && advance_seasonal && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)) || (!is_seasonal && (full_charge_at_kiosk || swipeMode))">
                <template v-if='$store.state.resources.config.google_recaptcha=="1" && $store.state.resources.config.google_recaptcha_site_key!=""'>
                    <div class="mt-5">
                        <div ref="kiosk_recaptcha"> </div>
                    </div>
                </template>
            </template>
            <div class="mt-5" >
                <errors-alert :errors="v__getErrors()"></errors-alert>
                <errors-alert v-if="typeof errorMessagesList !== 'undefined' && (typeof errorMessagesList === 'object' && errorMessagesList.length!==0 && v__getErrors().length===0)" :errors="errorMessagesList"></errors-alert>
                <v-btn
                    color="secondary"
                    :disabled="$store.state.config.stepLoading"
                    @click="go_back()"
                >
                    {{ 'Back'}}
                </v-btn>
                <v-btn
                    id="stripe-card-button"
                    color="primary"
                    :loading="$store.state.config.stepLoading"
                    :disabled="disabled_status"
                >
                    {{ payButtonText() }}
                </v-btn>
            </div>
        </template>
        <template v-else-if="! is_using_square">
            <template v-if="!cost.free_checkout">
                <payment-widget
                    v-if="(is_prepay && (prepay_payment || only_save_card_at_prepay)) || (is_seasonal && !advance_seasonal && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || (is_seasonal && advance_seasonal && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)) || (!is_seasonal && (full_charge_at_kiosk || swipeMode))"
                    :prepay="is_prepay"
                    :amount="((prepay_payment || only_save_card_at_prepay) && is_prepay) ? parseFloat(prepay_total_price).toFixed(2) : cost.amount_to_be_paid"
                    :swipe-mode="(is_seasonal && !advance_seasonal && credit_card_swipe_kiosk) || (is_seasonal && advance_seasonal && save_card_at_seasonal_advance_on) || (!is_seasonal && swipeMode)"
                    :validation-id="v__validationId" reservation-type="kiosk"></payment-widget>
            </template>
            <template v-if="((is_prepay && (prepay_payment || only_save_card_at_prepay)) || (is_seasonal && !advance_seasonal && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || (is_seasonal && advance_seasonal && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)) || (!is_seasonal && (full_charge_at_kiosk || swipeMode))) && !cost.free_checkout">
                <template v-if='$store.state.resources.config.google_recaptcha=="1" && $store.state.resources.config.google_recaptcha_site_key!=""'>
                    <div class="mt-5">
                        <h6>This site is protected by Google reCAPTCHA</h6>
                    </div>
                </template>
            </template>
            <template v-show="(is_prepay && (prepay_payment || only_save_card_at_prepay)) || (is_seasonal && !advance_seasonal && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || (is_seasonal && advance_seasonal && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)) || (!is_seasonal && (full_charge_at_kiosk || swipeMode))">
                <template v-if='$store.state.resources.config.google_recaptcha=="1" && $store.state.resources.config.google_recaptcha_site_key!=""'>
                    <div class="mt-5">
                        <div ref="kiosk_recaptcha"> </div>
                    </div>
                </template>
            </template>
            <steps-navigation :error-messages-list="errorMessagesList"
                              :errors="v__getErrors()" :next-button="(is_seasonal && !advance_seasonal && full_charge_at_seasonal_kiosk) || (is_seasonal && advance_seasonal && full_charge_at_seasonal_advance_on) || (!is_seasonal && full_charge_at_kiosk)  && !cost.free_checkout?'Pay':'Save'"
                              @step-back="stepBack({validate:false,submit:false})"
                              @step-next="stepNext({stay:true})"></steps-navigation>
        </template>
        <template v-else-if="is_using_square">
            <template v-if="!cost.free_checkout">
                <v-col cols="12" v-if="(is_prepay && (prepay_payment || only_save_card_at_prepay)) || (((is_seasonal && !advance_seasonal) && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || ((is_seasonal && advance_seasonal) && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)))  || (!is_seasonal && (full_charge_at_kiosk || swipeMode))">
                <v-card class="mt-5">
                    <v-card-title class="grey lighten-4 p-2" v-if="!kiosk_save_only">
                        <h4 class="m-0">
                            <span class=" error--text"> Reservation Total:</span> <span class="blue--text text--accent-4">${{ amount }}</span>
                        </h4>
                    </v-card-title>
                    <v-card-title class="grey lighten-4 p-2" v-else-if="kiosk_save_only && !fullCharge">
                        <h5 class="m-0 font-weight-bold error--text text-break">
                            We are saving your card information and are not charging you at this time
                        </h5>
                    </v-card-title>
                    <div class="p-2">

                    <span class="mt-5 error--text  text-break" v-if="reservation.is_seasonal && securitydeposit && !swipeMode && frontend_view_folder == 'frontend.highcountryskiandtennis'">
                        Please Enter Credit Card Information that is used as a security Deposit.
                    </span>

                        <template v-if="((!securitydeposit && is_seasonal && frontend_view_folder == 'frontend.highcountryskiandtennis') || !is_seasonal || (is_seasonal && frontend_view_folder !== 'frontend.highcountryskiandtennis')) && kiosk_save_only">
                            <div :class="(is_seasonal && kiosk_save_only)?'error--text':'mt-5 error--text'"> Reservation Total: <span class="blue--text text--accent-4">${{ amount }}</span></div>
                        </template>
                        <template v-if="securitydeposit && kiosk_save_only && is_seasonal && frontend_view_folder == 'frontend.highcountryskiandtennis'">
                            <div class=""> Total Rental: <span class="blue--text text--accent-4">${{ parseFloat( parseFloat(amount) - cost.deposit_total ).toFixed(2) }}</span></div>
                            <div class="error--text"> Deposit: <span class="blue--text text--accent-4">${{ parseFloat( cost.deposit_total ).toFixed(2) }}</span></div>
                            <div class="mb-5 error--text"> Total: <span class="blue--text text--accent-4">${{ parseFloat( amount ).toFixed(2) }}</span></div>
                        </template>
                        <div id="card-container"></div>
                    </div>
                </v-card>
            </v-col>
            </template>
            <v-col cols="12">
                <with-validation field="agreement" v-slot="{bind,on}">
                    <v-checkbox v-bind="bind"
                                v-on="on" v-if="(is_prepay && (prepay_payment || only_save_card_at_prepay)) || (is_seasonal && !advance_seasonal && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || (is_seasonal && advance_seasonal && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)) || (!is_seasonal && (full_charge_at_kiosk || swipeMode))">

                        <template v-slot:label>
                            I have read and agree to the
                            &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_terms'})">{{ terms_and_conditions_title }}</a>
                            ,
                            &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_privacy_policy'})">{{ privacy_policy_title }}</a>&nbsp;
                            and
                            &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_cancelation_policy'})">{{ cancellation_policy_title }}</a>
                        </template>
                    </v-checkbox>
                </with-validation>
            </v-col>
            <template v-if="((is_prepay && (prepay_payment || only_save_card_at_prepay)) || (is_seasonal && !advance_seasonal && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || (is_seasonal && advance_seasonal && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)) || (!is_seasonal && (full_charge_at_kiosk || swipeMode))) && !cost.free_checkout">
                <template v-if='$store.state.resources.config.google_recaptcha=="1" && $store.state.resources.config.google_recaptcha_site_key!=""'>
                    <div class="mt-5">
                        <h6>This site is protected by Google reCAPTCHA</h6>
                    </div>
                </template>
            </template>
            <template v-show="(is_prepay && (prepay_payment || only_save_card_at_prepay)) || (is_seasonal && !advance_seasonal && (full_charge_at_seasonal_kiosk || credit_card_swipe_kiosk)) || (is_seasonal && advance_seasonal && (full_charge_at_seasonal_advance_on || save_card_at_seasonal_advance_on)) || (!is_seasonal && (full_charge_at_kiosk || swipeMode))">
                <template v-if='$store.state.resources.config.google_recaptcha=="1" && $store.state.resources.config.google_recaptcha_site_key!=""'>
                    <div class="mt-5">
                        <div ref="kiosk_recaptcha"> </div>
                    </div>
                </template>
            </template>

            <div class="mt-5" >
                <errors-alert :errors="v__getErrors()"></errors-alert>
                <errors-alert v-if="typeof errorMessagesList !== 'undefined' && (typeof errorMessagesList === 'object' && errorMessagesList.length!==0 && v__getErrors().length===0)" :errors="errorMessagesList"></errors-alert>
                <v-btn
                    color="secondary"
                    :disabled="$store.state.config.stepLoading"
                    @click="go_back()"
                >
                    {{ 'Back'}}
                </v-btn>
                <v-btn
                    id="card-button"
                    color="primary"
                    :loading="$store.state.config.stepLoading"
                    :disabled="disabled_status"
                >
                    {{ payButtonText() }}
                </v-btn>
            </div>
        </template>

        <v-dialog v-model="messageDialog.show" persistent max-width="500px">
            <message-modal :message="messageDialog.message" :success="messageDialog.success"></message-modal>
        </v-dialog>
    </v-form>
</template>

<script>
import MessageModal          from "../../../components/modals/MessageModal";
import UiManagerMixin        from "../../../mixins/UiManagerMixin";
import RentersListTable      from "../../../components/partials/RentersListTable";
import StepsNavigation       from "../../../components/partials/StepsNavigation";
import ValidatableComponent  from "../../../mixins/ValidatableComponent";
import cc_form__rules        from "../../../validation/scenarios/cc_form__rules";
import TicketInformation     from "./step3/TicketInformation";
import RentalInformation     from "./step3/RentalInformation";
import AdditionalInformation from "./step3/AdditionalInformation";
import PaymentWidget         from "./step3/PaymentWidget";
import {mapActions, mapGetters} from "vuex";
import StepperComponentMixin from "../../../mixins/StepperComponentMixin";
import WithValidation           from "../../../components/inputs/WithValidation";
import ErrorsAlert from "../../../components/partials/ErrorsAlert";

export default {
    name      : "Step3",
    components: {
        MessageModal,
        PaymentWidget,
        WithValidation,
        ErrorsAlert,
        AdditionalInformation, RentalInformation, TicketInformation, RentersListTable, StepsNavigation
    },
    mixins    : [StepperComponentMixin, ValidatableComponent, UiManagerMixin],
    data      : () => ({
        form         : false,
        messageDialog: {
            show   : false,
            message: '',
            success: true,
        },
        is_prepay : false,
        errorMessagesList: [],
        stripe: null,
        advance_seasonal: false,
        cardElement: null,
        recaptchaWidgetId : null,
    }),
    methods   : {
        ...mapActions(['do_save_swipe_kiosk', 'do_save_renter_information_kiosk', 'do_pay_kiosk', 'do_store_prepay_reservation_checkout']),
        invisibleRecaptcha() {
            this.$store.commit('set_disabled_status', true);
            this.recaptchaWidgetId  = grecaptcha.render(this.$refs.kiosk_recaptcha, {
                'sitekey'  : this.$store.state.resources.config.google_recaptcha_site_key,
                'callback' : this.rcapchaCallback.bind(this)
            });

            if (this.hasRecaptchaRendered === false) {
                grecaptcha.execute();

                this.hasRecaptchaRendered = true;
            }
        },
        rcapchaCallback(response) {
            this.$store.commit('set_model_value', {
                path : 'model.payment.g_recaptcha_response',
                value: response
            });
            this.$store.commit('set_disabled_status', false);
            this.$store.commit('set_rechapcha_is_checked', true);
        },
        invisibleRecaptchaStripe() {

            this.recaptchaWidgetId  = grecaptcha.render(this.$refs.kiosk_recaptcha, {
                'sitekey'  : this.$store.state.resources.config.google_recaptcha_site_key,
                'callback' : this.rcapchaCallback
            });

            if (this.hasRecaptchaRendered === false) {
                grecaptcha.execute();

                this.hasRecaptchaRendered = true;
            }
        },
        // rcapchaCallback(){
        //     this.rechapchaIsChecked = true;
        //     this.$store.commit('set_disabled_status', false);
        // },
        async stepSubmit() {
            if(this.is_prepay && (this.prepay_payment || this.only_save_card_at_prepay)){
                const result = await this.do_store_prepay_reservation_checkout();
                if(result.data.success){
                    this.errorMessagesList = [];
                    console.log("first", result.data);
                    this.showMessage('Prepaid Successfully');
                    return true;
                }
                if(result.hasOwnProperty('errors')){
                    if(this.recaptchaWidgetId!= null){
                        grecaptcha.reset(this.recaptchaWidgetId);
                    }
                    this.errorMessagesList = [];
                    Object.values(result.data.errors).forEach(val => {
                        this.errorMessagesList.push(val[0]);
                    });
                }else if(result.hasOwnProperty('success') && !result.success) {
                    if(result.message!=="") {
                        if(this.recaptchaWidgetId!= null){
                            grecaptcha.reset(this.recaptchaWidgetId);
                        }
                        this.errorMessagesList = [result.message.includes(":") ? result.message.split(":")[1] : result.message];
                        return true;
                    }
                }
                else if(result.data.message!=="") {
                    if(this.recaptchaWidgetId!= null){
                        grecaptcha.reset(this.recaptchaWidgetId);
                    }
                    this.errorMessagesList = [result.data.message.includes(":")?result.data.message.split(":")[1]:result.data.message];
                }else{
                    this.errorMessagesList = [];
                    console.log("second", result.data);
                    this.showMessage('Prepaid Successfully');
                    return true;
                }
            }else {
                // alert(((this.is_seasonal && !this.advance_seasonal && this.full_charge_at_seasonal_kiosk) || (this.is_seasonal && this.advance_seasonal && this.full_charge_at_seasonal_advance_on) || (!this.is_seasonal && this.full_charge_at_kiosk)) && !this.$store.state.model.cost.free_checkout);

                    if(((this.is_seasonal && !this.advance_seasonal && this.full_charge_at_seasonal_kiosk) || (this.is_seasonal && this.advance_seasonal && this.full_charge_at_seasonal_advance_on) || (!this.is_seasonal && this.full_charge_at_kiosk)) && !this.$store.state.model.cost.free_checkout){
                    await this.do_save_renter_information_kiosk();
                    const result = await this.do_pay_kiosk();

                    if (result.hasOwnProperty('errors')) {
                        if(this.recaptchaWidgetId!= null){
                            grecaptcha.reset(this.recaptchaWidgetId);
                        }
                        if(result.hasOwnProperty('errors')){
                            this.errorMessagesList = [];
                            Object.values(result.errors).forEach(entry => {
                                const [key, value] = entry;
                                this.errorMessagesList.push(key);
                            });

                            return true;
                        }else if(result.message!=="") {
                            this.errorMessagesList = [result.message.includes(":") ? result.message.split(":")[1] : result.message];
                            return true;
                        }
                    }
                    if (result.hasOwnProperty('success') && !result.success) {
                        if(result.message!=="") {
                            if(this.recaptchaWidgetId!= null){
                                grecaptcha.reset(this.recaptchaWidgetId);
                            }
                            this.errorMessagesList = [result.message.includes(":") ? result.message.split(":")[1] : result.message];
                            return true;
                        }
                    }
                    if (result.data.hasOwnProperty('success') && !result.data.success) {
                        if(result.data.message!=="") {
                            if(this.recaptchaWidgetId!= null){
                                grecaptcha.reset(this.recaptchaWidgetId);
                            }
                            this.errorMessagesList = [result.data.message.includes(":") ? result.data.message.split(":")[1] : result.data.message];
                            return true;
                        }
                    }

                        if(this.auto_printing_is_enabled && !window.location.href.includes('seasonal') && this.frontend_view_folder == 'frontend.kenjonesskimart'){
                            if(this.is_seasonal){
                                window.location.href = '/reservations/seasonal_kiosk/print_form';
                            }else{
                                window.location.href = '/reservations/kiosk/print_form';
                            }
                        }else {
                            if (this.is_seasonal && this.is_appointment_booking_tool) {
                                let previous = window.location.href.includes('seasonal') ? 'seasonal' : 'kiosk';
                                window.location.href = '/reservation/'+result.data.id+'/appointment?previous='+(previous);
                                // window.location.href = "/front/service_ticket_step1/vue";
                            } else {
                                let currency = 'USD';
                                if(parseInt(this.$store.state.resources.config.is_international_canadian)){
                                    currency = 'CAD';
                                }
                                var currentUrl = window.location.hostname;
                                if (currentUrl == 'silverthorne.pioneersportscolorado.com') {
                                    gtag('event', 'conversion',
                                        {
                                            'send_to': 'AW-989270699/NaAkCKrTnIEYEKul3NcD',
                                            'value': 1.0,
                                            'currency': currency,
                                            'transaction_id': ''
                                        })
                                } else if (currentUrl == 'rentals.pioneersportscolorado.com') {
                                    gtag('event', 'conversion',
                                        {
                                            'send_to': 'AW-989270699/oqaXCNPvlIEYEKul3NcD',
                                            'value': 1.0,
                                            'currency': currency,
                                            'transaction_id': ''
                                        });
                                }
                                this.errorMessagesList = [];
                                console.log("third", result.data.id);
                                this.showMessage('Payment succeed! Thank you!');
                                return false;
                            }
                        }

                }else{
                    const save_only_result = await this.do_save_swipe_kiosk();
                    if (save_only_result.data.hasOwnProperty('errors')) {
                        if(this.recaptchaWidgetId!= null){
                            grecaptcha.reset(this.recaptchaWidgetId);
                        }
                        if(save_only_result.data.hasOwnProperty('errors')){

                            this.errorMessagesList = [];
                            Object.values(save_only_result.data.errors).forEach(entry => {

                                const [key, value] = entry;
                                this.errorMessagesList.push(key);
                            });
                            return true;
                        }else if(save_only_result.data.message!=="") {
                            this.errorMessagesList = [save_only_result.data.message.includes(":") ? save_only_result.data.message.split(":")[1] : save_only_result.data.message];
                            return true;
                        }
                    }else{
                        if((save_only_result.data.success === false || save_only_result.status !== 200) && !this.$store.state.model.cost.free_checkout){
                            if(this.recaptchaWidgetId!= null){
                                grecaptcha.reset(this.recaptchaWidgetId);
                            }
                            this.errorMessagesList = [save_only_result.data.message.includes(":")?save_only_result.data.message.split(":")[1]:save_only_result.data.message];
                            this.errorStatus = true;
                        } else {
                            this.errorMessagesList = [];
                            this.errorStatus = false;
                        }
                    }
                    if(!this.errorStatus){
                        let reservationId = '';
                        if((!this.is_seasonal && !this.full_charge_at_kiosk) || (this.is_seasonal && !this.advance_seasonal && !this.full_charge_at_seasonal_kiosk) || (this.is_seasonal && this.advance_seasonal && !this.full_charge_at_seasonal_advance_on) || this.$store.state.model.cost.free_checkout){
                            console.log("before do_save_renter_information_kiosk")
                            let response = await this.do_save_renter_information_kiosk();
                            console.log("after do_save_renter_information_kiosk", response.data.data.id);
                            reservationId = response.data.data.id;
                        }
                        if(this.auto_printing_is_enabled && !window.location.href.includes('seasonal') && this.frontend_view_folder == 'frontend.kenjonesskimart'){
                            if(this.is_seasonal){
                                window.location.href = '/reservations/seasonal_kiosk/print_form';
                            }else{
                                window.location.href = '/reservations/kiosk/print_form';
                            }
                        }else {
                            if (this.is_seasonal && this.appointment_switch) {
                                let previous = window.location.href.includes('seasonal') ? 'seasonal' : 'kiosk';
                                window.location.href = '/reservation/'+reservationId+'/appointment?previous='+(previous);
                                // window.location.href = "/front/service_ticket_step1/vue";
                            } else {
                                console.log("### log custom success");
                                this.showMessage('Reservation saved! Thank you!');
                            }
                        }
                    }
                }
            }
        },
        async main() {
            const that = this;
            let card;
            if (this.is_using_square && ((this.swipeMode || this.full_charge_at_kiosk) || (that.is_seasonal && !that.advance_seasonal && (that.seasonal_kiosk_payment_checkout == 1 || that.full_charge_at_seasonal_kiosk == 1)) || (that.is_seasonal && that.advance_seasonal && (that.full_charge_at_seasonal_advance_on == 1 || that.save_card_at_seasonal_advance_on == 1))) && !that.cost.free_checkout) {
                const payments = Square.payments(that.square_application_id, that.square_location_id);
                card = await payments.card();
                card.attach('#card-container');
            }

            async function eventHandler(event) {
                if ((that.swipeMode == 0 && that.full_charge_at_kiosk == 0 && ! that.is_seasonal) || (that.seasonal_kiosk_payment_checkout == 0 && that.full_charge_at_seasonal_kiosk ==0 && that.is_seasonal && !that.advance_seasonal) || (that.save_card_at_seasonal_advance_on == 0 && that.full_charge_at_seasonal_advance_on ==0 && that.is_seasonal && that.advance_seasonal) || that.cost.free_checkout) {
                    await that.stepSubmit();
                } else {
                    event.preventDefault();
                    try {
                        const result = await card.tokenize();
                        if (result.status === 'OK') {
                            that.$store.commit('set_model_value', {
                                path : 'model.payment.cc',
                                value: '4111111111111111'
                            });
                            that.$store.commit('set_model_value', {
                                path : 'model.payment.cvv',
                                value: '234'
                            });
                            that.$store.commit('set_model_value', {
                                path : 'model.payment._nounce',
                                value: result.token
                            });

                            await that.stepSubmit();
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            };
            const cardButton = document.getElementById('card-button');
            cardButton.addEventListener('click', eventHandler);
        },
        getValidationScenario() {
            return 'step_3';
        },
        showMessage(text, success) {
            let time = 2000;
            if(this.frontend_view_folder == 'frontend.mountain_haus' && this.auto_printing_is_enabled && !window.location.href.includes('seasonal')){
                time = 20000;
            }
            this.messageDialog.message = text;
            this.messageDialog.success = success === undefined ? true : success;
            this.messageDialog.show = true;
            const self = this;
            setTimeout(function(){
                self.messageDialog.show = false;
                self.reload();
            },time);
        },
        reload(){
            window.localStorage.removeItem('last_reservation_id');
            window.location.reload();
        },
        go_back(){
            let n = this.$store.state.currentStepId - 1;
            this.$store.commit('set_step_id', n);
        },
        async mainStripe() {
            const that = this;
            let elements;
            let card;

            if (that.$store.state.resources.config.gateway =='stripe' && !that.cost.free_checkout && ((that.is_prepay && (that.prepay_payment || that.only_save_card_at_prepay)) || (((that.is_seasonal && !that.advance_seasonal) && (that.full_charge_at_seasonal_kiosk || that.credit_card_swipe_kiosk)) || ((that.is_seasonal && that.advance_seasonal) && (that.full_charge_at_seasonal_advance_on || that.save_card_at_seasonal_advance_on))) || (!that.is_seasonal && (that.full_charge_at_kiosk || that.swipeMode)))) {

                that.stripe = Stripe(that.$store.state.resources.config.stripe_publish);
                elements = this.stripe.elements();

                that.cardElement = elements.create('card', {
                    style: {
                        base: {
                            fontSize: '16px',
                        },
                    },
                    hidePostalCode: true,
                    disableLink: true,
                });
                // this.cardElement = caed;

                that.cardElement.mount('#card-element');

                that.cardElement.on('change', function (event) {
                    if (event.complete) {
                        if(that.recaptchaWidgetId != null && that.$store.state.resources.config.google_recaptcha=="1" && that.$store.state.resources.config.google_recaptcha_site_key!=''){
                            if(that.rechapcha_is_checked){
                                that.$store.commit('set_disabled_status', false);
                            }else{
                                that.$store.commit('set_disabled_status', true);
                            }
                        }else{
                            that.$store.commit('set_disabled_status', false);
                        }
                    } else {
                        if(that.recaptchaWidgetId != null && that.$store.state.resources.config.google_recaptcha=="1" && that.$store.state.resources.config.google_recaptcha_site_key!=''){
                            if(that.rechapcha_is_checked){
                                that.$store.commit('set_disabled_status', false);
                            }else{
                                that.$store.commit('set_disabled_status', true);
                            }
                        }else{
                            that.$store.commit('set_disabled_status', true);
                        }
                    }
                    // if(event.error != undefined){
                    //     if(that.recaptchaWidgetId == null && that.$store.state.resources.config.google_recaptcha=="1" && that.$store.state.resources.config.google_recaptcha_site_key!=''){
                    //         that.$store.commit('set_disabled_status', true);
                    //         that.invisibleRecaptchaStripe();
                    //     }
                    // }
                });

            }

            async function eventHandler(event) {
                if(that.$store.state.model.payment.kiosk_cash_pay || that.cost.free_checkout ){
                    await that.stepSubmit();
                }else{
                    if ((that.is_prepay && (that.prepay_payment || that.only_save_card_at_prepay)) || (((that.is_seasonal && !that.advance_seasonal) && (that.full_charge_at_seasonal_kiosk || that.credit_card_swipe_kiosk)) || ((that.is_seasonal && that.advance_seasonal) && (that.full_charge_at_seasonal_advance_on || that.save_card_at_seasonal_advance_on))) || (!that.is_seasonal && (that.full_charge_at_kiosk || that.swipeMode))) {

                        event.preventDefault();
                        try {
                            that.$store.commit('set_step_loading', true);
                            const { token, error } = await that.stripe.createToken(that.cardElement);
                            if (error) {
                                // Handle errors
                                console.error(error);
                                that.$store.commit('set_step_loading', false);
                            } else {
                                that.$store.commit('set_model_value', {
                                    path : 'model.payment.cc',
                                    value: token.card.last4
                                });

                                that.$store.commit('set_model_value', {
                                    path : 'model.payment.stripeToken',
                                    value: token.id
                                });

                                await that.stepSubmit();
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    } else {
                        await that.stepSubmit();
                    }
                }

            }

            const cardButton = document.getElementById('stripe-card-button');
            cardButton.addEventListener('click', eventHandler);
        },
        
        payButtonText() {
            if(this.is_prepay && (this.prepay_payment || this.only_save_card_at_prepay)){
                return this.kiosk_save_only && !this.fullCharge ? 'Save' : 'Pay';
            }else if(this.is_seasonal && !this.advance_seasonal && (this.full_charge_at_seasonal_kiosk || this.credit_card_swipe_kiosk)){
                return this.kiosk_save_only && !this.fullCharge ? 'Save' : 'Pay';
            }else if(this.is_seasonal && this.advance_seasonal && (this.full_charge_at_seasonal_advance_on || this.save_card_at_seasonal_advance_on)){
                return this.kiosk_save_only && !this.fullCharge ? 'Save' : 'Pay';
            }else if(!this.is_seasonal && (this.full_charge_at_kiosk || this.swipeMode)){
                return this.kiosk_save_only && !this.fullCharge ? 'Save' : 'Pay';
            }else{
                return 'Save';
            }
        }
    },
    computed  : {
        cost() {
            return this.$store.state.model.cost;
        },
        only_save_card_at_advanced() {
            return parseInt(this.$store.state.resources.config.only_save_card_at_advanced);
        },
        advance_reservation_payment_checkout() {
            return parseInt(this.$store.state.resources.config.advance_reservation_payment_checkout);
        },
        full_charge_at_kiosk() {
            return parseInt(this.$store.state.resources.config.full_charge_at_kiosk);
        },
        appointment_switch() {
            return parseInt(this.$store.state.resources.config.appointment_switch);
        },
        seasonal_kiosk_payment_checkout() {
            return parseInt(this.$store.state.resources.config.credit_card_swipe_kiosk);
        },
        full_charge_at_seasonal_kiosk() {
            return parseInt(this.$store.state.resources.config.full_charge_at_seasonal_kiosk);
        },
        is_seasonal(){
            return parseInt(this.$store.state.model.reservation.is_seasonal);
        },
        notes_on_kiosk(){
            return parseInt(this.$store.state.resources.config.notes_on_kiosk);
        },
        swipeMode() {
            return parseInt(this.$store.state.resources.config.credit_card_swipe);
        },
        credit_card_swipe_kiosk() {
            return parseInt(this.$store.state.resources.config.credit_card_swipe_kiosk);
        },
        prepay_payment(){
            return parseInt(this.$store.state.resources.config.prepay_payment);
        },
        only_save_card_at_prepay(){
            return parseInt(this.$store.state.resources.config.only_save_card_at_prepay);
        },
        securitydeposit(){
            return parseInt(this.$store.state.resources.config.securitydeposit);
        },
        reservation() {
            return this.$store.state.model.reservation;
        },
        is_using_square() {
            return this.$store.state.resources.config.is_using_squareup
        },
        square_application_id() {
            return this.$store.state.resources.config.square_application_id
        },
        square_location_id() {
            return this.$store.state.resources.config.square_location_id
        },
        kiosk_save_only() {
            return (this.is_seasonal && !window.location.href.includes('seasonal') && this.credit_card_swipe_kiosk) || (this.is_seasonal && window.location.href.includes('seasonal') && this.save_card_at_seasonal_advance_on) || (!this.is_seasonal && this.swipeMode)
        },
        fullCharge(){
            return (this.is_seasonal && this.full_charge_at_seasonal_kiosk) || (!this.is_seasonal && this.full_charge_at_kiosk)
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        auto_printing_is_enabled() {
            return parseInt(this.$store.state.resources.config.auto_printing_is_enabled);
        },
        amount() {
            return ((this.prepay_payment || this.only_save_card_at_prepay) && this.is_prepay) ? parseFloat(this.prepay_total_price).toFixed(2) : this.cost.amount_to_be_paid
        },
        gateway(){
            return this.$store.state.resources.config.gateway;
        },
        stripe_publish(){
            return this.$store.state.resources.config.stripe_publish
        },
        full_charge_at_seasonal_advance_on(){
            return parseInt(this.$store.state.resources.config.full_charge_at_seasonal_advance_on);
        },
        save_card_at_seasonal_advance_on(){
            return parseInt(this.$store.state.resources.config.save_card_at_seasonal_advance_on);
        },
        cash_pay_switch() {
            return parseInt(this.$store.state.resources.config.cash_pay_switch);
        },
        seasonal_kiosk_cash_pay() {
            return parseInt(this.$store.state.resources.config.seasonal_kiosk_cash_pay);
        },
        kiosk_cash_pay() {
            return parseInt(this.$store.state.resources.config.kiosk_cash_pay);
        },
        is_appointment_booking_tool() {
            return parseInt(this.$store.state.resources.kiosk_config.is_appointment_booking_tool);
        },
        terms_and_conditions_title() {
            return this.$store.state.resources?.policy_and_terms?.terms_and_conditions?.title || 'Terms & Conditions'
        },
        privacy_policy_title() {
            return this.$store.state.resources?.policy_and_terms?.privacy_policy?.title || 'Privacy Policy'
        },
        cancellation_policy_title() {
            return this.$store.state.resources?.policy_and_terms?.cancellation_policy?.title || 'Cancellation Policy'
        },
        ...mapGetters(['prepay_total_price', 'disabled_status', 'rechapcha_is_checked'])
    },
    watch     : {
        '$store.state.model.payment.kiosk_cash_pay': function (newVal, oldVal) {
            if(newVal){
                this.cardElement.update({
                    validateCardNumber: false,
                    validateExpiryDate: false,
                    validateCVC: false,
                });
                this.$store.commit('set_disabled_status', false);
            }else{
                this.cardElement.update({
                    validateCardNumber: true,
                    validateExpiryDate: true,
                    validateCVC: true,
                });
            }
        }
    },
    created(){
        if(this.$store.state.resources.config.demo_card && this.$store.state.resources.config.demo_card!==""){
            this.$store.commit('set_model_value', {
                path : 'model.payment.cc',
                value: this.$store.state.resources.config.demo_card
            });
        }
    },
    mounted() {
        this.main();
        if(this.$store.state.resources.config.gateway =='stripe'){
            this.mainStripe();
        }

        if(this.$store.state.resources.config.gateway =='stripe' || this.$store.state.resources.config.gateway =='squareup'){
                let next_year = parseInt(new Date().getFullYear()) + 1;
                next_year = next_year.toString();
                this.$store.commit('set_model_value', {
                    path : 'model.payment.expiration_year',
                    value: next_year
                });
                this.$store.commit('set_model_value', {
                    path : 'model.payment.expiration_month',
                    value: '01'
                });
        }
        const self = this;
        if (window.location.href.includes('prepay')) {
            self.is_prepay = true;
        }
        if(window.location.href.includes('seasonal')){
            self.advance_seasonal = true;
        }
        if((self.is_prepay && (self.prepay_payment || self.only_save_card_at_prepay)) || (self.is_seasonal && !self.advance_seasonal && (self.full_charge_at_seasonal_kiosk || self.credit_card_swipe_kiosk)) || (self.is_seasonal && self.advance_seasonal && (self.full_charge_at_seasonal_advance_on || self.save_card_at_seasonal_advance_on)) || (!self.is_seasonal && (self.full_charge_at_kiosk || self.swipeMode))){
            if(this.recaptchaWidgetId == null && this.$store.state.resources.config.google_recaptcha=="1" && this.$store.state.resources.config.google_recaptcha_site_key!=''){
                if(!self.$store.state.model.cost.free_checkout){
                    this.invisibleRecaptcha();
                }
            };
        }

        this.withValidation({
            getModel() {
                return self.$store.state.model.payment;
            },
            rules : {},
            fields: {}
        })

    }
}
</script>

<style scoped>
    #card-element{
        padding: 15px;
        border-radius: 4px;
        background: #f8f9fa;
        margin: 15px 0;
    }
</style>
